import type { HotelApi } from '@revolugo/booking-api-client'
import type {
  ComputedHotelImage,
  CountryIso2Code,
  Hotel,
} from '@revolugo/graphql/private'

export interface HotelAdapterProps
  extends Pick<
    Hotel,
    | 'name'
    | 'id'
    | 'address'
    | 'postalCode'
    | 'city'
    | 'countryCode'
    | 'timezone'
    | 'hotelImages'
  > {
  checkInTime: string
  checkOutTime: string
}

export class HotelAdapter {
  public hotelApi: HotelApi

  constructor(hotelApi: HotelApi) {
    this.hotelApi = hotelApi
  }

  public toHotel(): HotelAdapterProps {
    return {
      ...this.hotelApi,
      address: this.hotelApi.address,
      checkInTime: this.hotelApi.checkInTime!,
      checkOutTime: this.hotelApi.checkOutTime!,
      city: this.hotelApi.city,
      countryCode: this.hotelApi.countryCode as CountryIso2Code,
      hotelImages: this.mapHotelImagesToComputedHotelImages(),
      id: this.hotelApi.id,
      name: this.hotelApi.name || '',
      postalCode: this.hotelApi.postalCode,
    }
  }

  private mapHotelImagesToComputedHotelImages(): ComputedHotelImage[] {
    return this.hotelApi.hotelImages!.map(hotelImage => ({
      isHeroImage: hotelImage.isHeroImage!,
      l: hotelImage.l!,
      m: hotelImage.m!,
      s: hotelImage.s!,
      xl: hotelImage.xl!,
      xs: hotelImage.xs!,
    }))
  }
}
